import { LoginOutput } from '@allocab/allocab-commons-shared-types';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import { queryKeys } from '../services/datastore/queryKeys';
import { storage } from '../services/storage/storage';
import { clearTokens, TOKENS_STORAGE_KEY, updateTokens } from '../utils/auth';

const fetchTokens = () => storage.getJSONItem<LoginOutput>(TOKENS_STORAGE_KEY);

export const useTokens = () => {
  const { data: tokens, isFetched } = useQuery(queryKeys.tokens(), fetchTokens, {
    staleTime: Infinity,
    cacheTime: Infinity,
  });

  useEffect(() => {
    if (tokens !== undefined) {
      storage.setJSONItem(TOKENS_STORAGE_KEY, tokens);
    }
  }, [tokens]);

  return { tokens, updateTokens, clearTokens, isFetched };
};
